function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "OneTrust Home Loans");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#345670",
  points: "92 30.8 80.2 44.4 125.4 112.8 125.4 133.4 150 120.4 92 30.8"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#345670",
  points: "154.4 117.9 90 18.4 14.7 106.1 0 44.4 91.7 10.7 157.8 116.2 154.4 117.9"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#345670",
  x: 77.7,
  y: 77.7,
  width: 15.5,
  height: 19
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#345670",
  x: 59.7,
  y: 77.7,
  width: 15.5,
  height: 19
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#345670",
  x: 77.7,
  y: 99.5,
  width: 15.5,
  height: 19
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#345670",
  x: 59.7,
  y: 99.5,
  width: 15.5,
  height: 19
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M207.5,36.1c0,23.2-14.1,37.3-34.8,37.3-21,0-33.3-15.9-33.3-36C139.4,16.2,152.9.3,173.8.3,195.7.3,207.5,16.6,207.5,36.1Zm-51.1,1c0,13.9,6.5,23.6,17.2,23.6s17-10.3,17-24c0-12.7-6.1-23.6-17.1-23.6C162.7,13,156.4,23.3,156.4,37.1Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M215.8,37.3c0-6.4-.2-11.9-.4-16.4h13.9l.7,7h.3a18.64,18.64,0,0,1,15.9-8.2c10.5,0,18.4,6.9,18.4,22V72.1h-16V43.8c0-6.6-2.3-11.1-8.1-11.1-4.4,0-7,3-8.1,6a11.24,11.24,0,0,0-.6,4V72.3h-16v-35Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M287.6,51.7c.5,6.6,7,9.8,14.5,9.8a44.19,44.19,0,0,0,14.2-2.1l2.1,10.8a50.72,50.72,0,0,1-18.6,3.1c-17.4,0-27.4-10.1-27.4-26.1,0-13,8.1-27.4,25.9-27.4,16.6,0,22.9,12.9,22.9,25.6a40.63,40.63,0,0,1-.5,6.3Zm18.7-10.9c0-3.9-1.7-10.4-9-10.4-6.7,0-9.4,6.1-9.9,10.4Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M336.8,14.9h-19V1.5h54.4V14.9H352.9V72.2H336.8Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M372.4,37.8c0-7.6-.2-12.5-.4-16.9h13.8l.5,9.4h.4c2.6-7.5,8.9-10.6,13.9-10.6a17.77,17.77,0,0,1,3.4.2v15a24.21,24.21,0,0,0-4.3-.4c-5.9,0-9.9,3.1-10.9,8.1a20.16,20.16,0,0,0-.3,3.6v26h-16V37.8Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M458.3,55.8c0,6.7.2,12.2.4,16.5H444.8l-.7-7.2h-.3c-2,3.1-6.8,8.4-16.1,8.4-10.4,0-18.1-6.5-18.1-22.4V20.9h16.1V48.5c0,7.5,2.4,12,8,12a8.6,8.6,0,0,0,8-5.6,9.25,9.25,0,0,0,.5-3.5V20.9h16.1Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M466.8,58.3a30.76,30.76,0,0,0,13.8,3.9c4.8,0,6.8-1.7,6.8-4.3s-1.6-3.9-7.6-5.9c-10.6-3.6-14.7-9.3-14.6-15.4,0-9.6,8.2-16.8,20.9-16.8a35.92,35.92,0,0,1,14.5,2.9l-2.8,11a24.57,24.57,0,0,0-11.1-2.9c-3.9,0-6.1,1.6-6.1,4.2,0,2.4,2,3.7,8.3,5.9,9.8,3.4,13.9,8.3,14,15.9,0,9.6-7.6,16.6-22.3,16.6-6.7,0-12.7-1.5-16.6-3.6Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M528.2,6.2V20.9h11.4V32.7H528.2V51.3c0,6.2,1.5,9,6.3,9a26.44,26.44,0,0,0,4.7-.4l.1,12.1a32.33,32.33,0,0,1-10.4,1.4c-5.1,0-9.5-1.8-12-4.4-2.9-3-4.4-8-4.4-15.2v-21h-6.8V20.9h6.8V9.8Z",
  transform: "translate(-0.3 -0.3)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M229.7,90.2V102h13.7V90.2h3.7v28.3h-3.7V105.2H229.7v13.3H226V90.2Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M276.5,104c0,9.7-5.9,14.9-13.1,14.9-7.5,0-12.7-5.8-12.7-14.4,0-9,5.6-14.9,13.1-14.9C271.5,89.7,276.5,95.6,276.5,104Zm-22,.5c0,6,3.3,11.5,9,11.5s9.1-5.3,9.1-11.8c0-5.6-2.9-11.5-9-11.5S254.5,98.3,254.5,104.5Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M304,106c-.2-3.9-.5-8.7-.4-12.2h-.1c-1,3.3-2.1,6.8-3.6,10.8l-5,13.7h-2.8l-4.6-13.5c-1.3-4-2.5-7.6-3.3-11h-.1c-.1,3.5-.3,8.3-.5,12.5l-.8,12.1h-3.5l2-28.3H286l4.8,13.7c1.2,3.5,2.1,6.6,2.9,9.5h.1a84.31,84.31,0,0,1,3-9.5l5-13.7h4.7l1.8,28.3h-3.6Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M327.5,105.2h-11v10.2h12.3v3.1H312.9V90.2h15.3v3.1H316.6v8.9h11v3Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M340.2,90.2h3.7v25.2H356v3.1H340.2Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M381.5,104c0,9.7-5.9,14.9-13.1,14.9-7.5,0-12.7-5.8-12.7-14.4,0-9,5.6-14.9,13.1-14.9C376.5,89.7,381.5,95.6,381.5,104Zm-22,.5c0,6,3.3,11.5,9,11.5s9.1-5.3,9.1-11.8c0-5.6-2.9-11.5-9-11.5S359.5,98.3,359.5,104.5Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M389.1,109.6l-2.9,8.9h-3.8L392,90.2h4.4l9.7,28.3h-3.9l-3-8.9Zm9.3-2.9-2.8-8.1c-.6-1.8-1-3.5-1.5-5.2H394c-.4,1.7-.9,3.4-1.4,5.1l-2.8,8.2Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M409.2,118.5V90.2h4l9.1,14.3a88,88,0,0,1,5.1,9.2h.1c-.3-3.8-.4-7.2-.4-11.6V90.2h3.4v28.3h-3.7l-9-14.4a83,83,0,0,1-5.3-9.5h-.1c.2,3.6.3,7,.3,11.7v12.1h-3.5Z",
  transform: "translate(-0.3 -0.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6b6b6b",
  d: "M435.2,114a12.86,12.86,0,0,0,6.6,1.8c3.7,0,5.9-2,5.9-4.8,0-2.6-1.5-4.2-5.3-5.6-4.6-1.6-7.5-4-7.5-8,0-4.4,3.7-7.7,9.2-7.7a13.32,13.32,0,0,1,6.3,1.4l-1,3a11.31,11.31,0,0,0-5.4-1.3c-3.9,0-5.3,2.3-5.3,4.2,0,2.6,1.7,3.9,5.6,5.5,4.8,1.8,7.2,4.2,7.2,8.3,0,4.4-3.2,8.1-9.9,8.1a14.67,14.67,0,0,1-7.2-1.8Z",
  transform: "translate(-0.3 -0.3)"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539.3,
    height: 133.4,
    viewBox: "0 0 539.3 133.4"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/othl-logo-color.77e29f40.svg";
export { SvgComponent as ReactComponent };